module.exports = __webpack_public_path__ + "static/duckie-zoom-78b273f38664b5be238700996785ea36.jpg";